// maths.portll.net — provider-config module.
//
// Enabling Apple Sign In later is a ONE-FLAG change here (VITE_APPLE_SIGN_IN_ENABLED),
// not a code edit scattered across login screens. Apple is mandatory the moment the
// iPad app offers any third-party login (App Store guideline 4.8) — the Firebase Apple
// provider is configured from day one; only the button is gated behind the flag.

import { signInWithGoogle, signInWithApple } from "./firebase.js";

const APPLE_ENABLED =
  import.meta.env.VITE_APPLE_SIGN_IN_ENABLED === "1" ||
  import.meta.env.VITE_APPLE_SIGN_IN_ENABLED === "true";

/** Ordered list of OAuth providers to render as buttons on the login screen. */
export const OAUTH_PROVIDERS = [
  { id: "google", label: "Continue with Google", signIn: signInWithGoogle, enabled: true },
  { id: "apple", label: "Continue with Apple", signIn: signInWithApple, enabled: APPLE_ENABLED },
].filter((p) => p.enabled);
